import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { DialogLoaderService } from "./services/dialog-loader/dialog-loader.service";

@Component({
    selector: 't-llevo-base-dialog-stepper-form',
    standalone: true,
    imports: [
      CommonModule,
    ],
    template: '',
    providers: [
        DialogLoaderService
    ]
})
export class BaseDialogStepperFormComponent<T extends AbstractControl>{
  @Input({required: true})frm!: T
  @Input() loaderSrv!: DialogLoaderService;
  @Input() focusOnFirstInput: boolean = false
  protected loaderId!: number

  firstInputOnBlur(){
    this.focusOnFirstInput = false
  }
}